'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var defer = require('p-defer');

var _require = require('../errors'),
    NotStartedError = _require.NotStartedError,
    AlreadyInitializedError = _require.AlreadyInitializedError;

var Components = require('./');

module.exports = function (_ref) {
  var apiManager = _ref.apiManager,
      constructorOptions = _ref.options,
      bitswap = _ref.bitswap,
      blockService = _ref.blockService,
      gcLock = _ref.gcLock,
      initOptions = _ref.initOptions,
      ipld = _ref.ipld,
      ipns = _ref.ipns,
      keychain = _ref.keychain,
      libp2p = _ref.libp2p,
      mfsPreload = _ref.mfsPreload,
      peerInfo = _ref.peerInfo,
      pinManager = _ref.pinManager,
      preload = _ref.preload,
      print = _ref.print,
      repo = _ref.repo;
  return /*#__PURE__*/function () {
    var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stopPromise, _apiManager$update, cancel, api;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              stopPromise = defer();
              _apiManager$update = apiManager.update({
                stop: function stop() {
                  return stopPromise.promise;
                }
              }), cancel = _apiManager$update.cancel;
              _context.prev = 2;
              blockService.unsetExchange();
              bitswap.stop();
              preload.stop();
              _context.next = 8;
              return Promise.all([ipns.republisher.stop(), mfsPreload.stop(), libp2p.stop(), repo.close()]);

            case 8:
              // Clear our addresses so we can start clean
              peerInfo.multiaddrs.clear();
              api = createApi({
                apiManager: apiManager,
                constructorOptions: constructorOptions,
                blockService: blockService,
                gcLock: gcLock,
                initOptions: initOptions,
                ipld: ipld,
                keychain: keychain,
                peerInfo: peerInfo,
                pinManager: pinManager,
                preload: preload,
                print: print,
                repo: repo
              });
              apiManager.update(api, function () {
                throw new NotStartedError();
              });
              _context.next = 18;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              cancel();
              stopPromise.reject(_context.t0);
              throw _context.t0;

            case 18:
              stopPromise.resolve(apiManager.api);
              return _context.abrupt("return", apiManager.api);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 13]]);
    }));

    function stop() {
      return _stop.apply(this, arguments);
    }

    return stop;
  }();
};

function createApi(_ref2) {
  var apiManager = _ref2.apiManager,
      constructorOptions = _ref2.constructorOptions,
      blockService = _ref2.blockService,
      gcLock = _ref2.gcLock,
      initOptions = _ref2.initOptions,
      ipld = _ref2.ipld,
      keychain = _ref2.keychain,
      peerInfo = _ref2.peerInfo,
      pinManager = _ref2.pinManager,
      preload = _ref2.preload,
      print = _ref2.print,
      repo = _ref2.repo;
  var dag = {
    get: Components.dag.get({
      ipld: ipld,
      preload: preload
    }),
    resolve: Components.dag.resolve({
      ipld: ipld,
      preload: preload
    }),
    tree: Components.dag.tree({
      ipld: ipld,
      preload: preload
    })
  };
  var object = {
    data: Components.object.data({
      ipld: ipld,
      preload: preload
    }),
    get: Components.object.get({
      ipld: ipld,
      preload: preload
    }),
    links: Components.object.links({
      dag: dag
    }),
    new: Components.object.new({
      ipld: ipld,
      preload: preload
    }),
    patch: {
      addLink: Components.object.patch.addLink({
        ipld: ipld,
        gcLock: gcLock,
        preload: preload
      }),
      appendData: Components.object.patch.appendData({
        ipld: ipld,
        gcLock: gcLock,
        preload: preload
      }),
      rmLink: Components.object.patch.rmLink({
        ipld: ipld,
        gcLock: gcLock,
        preload: preload
      }),
      setData: Components.object.patch.setData({
        ipld: ipld,
        gcLock: gcLock,
        preload: preload
      })
    },
    put: Components.object.put({
      ipld: ipld,
      gcLock: gcLock,
      preload: preload
    }),
    stat: Components.object.stat({
      ipld: ipld,
      preload: preload
    })
  };
  var pin = {
    add: Components.pin.add({
      pinManager: pinManager,
      gcLock: gcLock,
      dag: dag
    }),
    ls: Components.pin.ls({
      pinManager: pinManager,
      dag: dag
    }),
    rm: Components.pin.rm({
      pinManager: pinManager,
      gcLock: gcLock,
      dag: dag
    })
  }; // FIXME: resolve this circular dependency

  dag.put = Components.dag.put({
    ipld: ipld,
    pin: pin,
    gcLock: gcLock,
    preload: preload
  });
  var block = {
    get: Components.block.get({
      blockService: blockService,
      preload: preload
    }),
    put: Components.block.put({
      blockService: blockService,
      gcLock: gcLock,
      preload: preload
    }),
    rm: Components.block.rm({
      blockService: blockService,
      gcLock: gcLock,
      pinManager: pinManager
    }),
    stat: Components.block.stat({
      blockService: blockService,
      preload: preload
    })
  };
  var add = Components.add({
    block: block,
    preload: preload,
    pin: pin,
    gcLock: gcLock,
    options: constructorOptions
  });
  var resolve = Components.resolve({
    ipld: ipld
  });
  var refs = Components.refs({
    ipld: ipld,
    resolve: resolve,
    preload: preload
  });
  refs.local = Components.refs.local({
    repo: repo
  });

  var notStarted = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              throw new NotStartedError();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function notStarted() {
      return _ref3.apply(this, arguments);
    };
  }();

  var api = {
    add: add,
    bitswap: {
      stat: notStarted,
      unwant: notStarted,
      wantlist: notStarted
    },
    block: block,
    bootstrap: {
      add: Components.bootstrap.add({
        repo: repo
      }),
      list: Components.bootstrap.list({
        repo: repo
      }),
      rm: Components.bootstrap.rm({
        repo: repo
      })
    },
    cat: Components.cat({
      ipld: ipld,
      preload: preload
    }),
    config: Components.config({
      repo: repo
    }),
    dag: dag,
    dns: Components.dns(),
    files: Components.files({
      ipld: ipld,
      block: block,
      blockService: blockService,
      repo: repo,
      preload: preload,
      options: constructorOptions
    }),
    get: Components.get({
      ipld: ipld,
      preload: preload
    }),
    id: Components.id({
      peerInfo: peerInfo
    }),
    init: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throw new AlreadyInitializedError();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }(),
    isOnline: Components.isOnline({}),
    key: {
      export: Components.key.export({
        keychain: keychain
      }),
      gen: Components.key.gen({
        keychain: keychain
      }),
      import: Components.key.import({
        keychain: keychain
      }),
      info: Components.key.info({
        keychain: keychain
      }),
      list: Components.key.list({
        keychain: keychain
      }),
      rename: Components.key.rename({
        keychain: keychain
      }),
      rm: Components.key.rm({
        keychain: keychain
      })
    },
    ls: Components.ls({
      ipld: ipld,
      preload: preload
    }),
    object: object,
    pin: pin,
    refs: refs,
    repo: {
      gc: Components.repo.gc({
        gcLock: gcLock,
        pin: pin,
        pinManager: pinManager,
        refs: refs,
        repo: repo
      }),
      stat: Components.repo.stat({
        repo: repo
      }),
      version: Components.repo.version({
        repo: repo
      })
    },
    resolve: resolve,
    start: Components.start({
      apiManager: apiManager,
      options: constructorOptions,
      blockService: blockService,
      gcLock: gcLock,
      initOptions: initOptions,
      ipld: ipld,
      keychain: keychain,
      peerInfo: peerInfo,
      pinManager: pinManager,
      preload: preload,
      print: print,
      repo: repo
    }),
    stats: {
      bitswap: notStarted,
      bw: notStarted,
      repo: Components.repo.stat({
        repo: repo
      })
    },
    stop: function stop() {
      return apiManager.api;
    },
    swarm: {
      addrs: notStarted,
      connect: notStarted,
      disconnect: notStarted,
      localAddrs: Components.swarm.localAddrs({
        peerInfo: peerInfo
      }),
      peers: notStarted
    },
    version: Components.version({
      repo: repo
    })
  };
  return api;
}